(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      Reflex.registerEventHandler("ready", this.onReady.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(
        this.name + ":winningsTextContainer"
      );
      this._mainText = resourceManager.get(
        this.name + ":winningsTextContainer:winningsText"
      );
      this._shadowText = resourceManager.get(
        this.name + ":winningsTextContainer:winningsShadow"
      );

      this._winningsTextFlash = resourceManager.get(
        this.name + ":winningsTextContainer:winningsTextFlash"
      );
      this._winningsTextFlash.visible = false;

      this._blackMask = resourceManager.get(
        this.name + ":winningsTextContainer:blackmask"
      );

      this._multiplierContainer = resourceManager.get(
        "slotContainer:multiplierTextContainer"
      );
      this._multiplier = resourceManager.get(
        "slotContainer:multiplierTextContainer:multiplierText"
      );

      this._multiplierPositionX = resourceManager
        .get("slotContainer:multiplierTextContainer")
        .position.getX();
      this._multiplierPositionY = resourceManager
        .get("slotContainer:multiplierTextContainer")
        .position.getY();

      this.emitter = particleManager.createEmitter(
        "multiplierDustEmitter",
        "slotContainer:particlesContainer",
        0,
        0,
        false
      );
      this.emitter.particleEmitter.emit = false;

      this._shadowText.tint = 0x000000;
      this._shadowText.alpha = 0.7;

      this._multiplierContainer.visible = false;
      this._currentMultiplierScale = 0;

      this.show(false);
    };

    resetMultiplierPosition() {
      this.onOrientationChange();

      this._multiplierContainer.position.x = this._multiplierPositionX;
      this._multiplierContainer.position.y = this._multiplierPositionY;
    }

    moveMultiplier(winnings) {
      var moveAmount = 150;
      var targetY = this._multiplierContainer.position.y - moveAmount;

      gsap.to(this._multiplierContainer, {
        duration: 0.6,
        y: targetY,
        onComplete: () => {
          this.setMultiplierScale(0);
          this.setText(winnings);

          this.emitter.particleEmitter.spawnPos.x = this.x;
          this.emitter.particleEmitter.spawnPos.y = this.y;
          this.emitter.particleEmitter.emit = true;

          this._winningsTextFlash.visible = true;
          this._winningsTextFlash.alpha = 0.8;
          this._winningsTextFlash.scale.x = 1;
          this._winningsTextFlash.scale.y = 1;

          this._multiplierContainer.position.y = targetY + moveAmount;

          soundManager.play("explode");

          gsap.to(this._winningsTextFlash, {
            duration: 0.4,
            pixi: { scaleX: 1.6, scaleY: 1.6 },
            alpha: 0,
            onComplete: () => {
              this._winningsTextFlash.visible = false;
            },
          });
        },
        ease: "back.in(4)",
      });
    }

    onOrientationChange() {
      this._multiplierPositionX = resourceManager
        .get("slotContainer:multiplierTextContainer")
        .position.getX();
      this._multiplierPositionY = resourceManager
        .get("slotContainer:multiplierTextContainer")
        .position.getY();
    }

    setText = function (value) {
      var valueText = gdk.formatCurrency(value);
      this._mainText.setText(valueText);
      this._winningsTextFlash.setText(valueText);
      this._shadowText.setText(valueText);

      var numCharacters = valueText.length;
      let width = numCharacters * 120 + 20;

      let normalWidth = 5 * 120 + 20;
      let scale = width / normalWidth;
      this._blackMask.scale.set(scale, 1);
    };

    show = function (show, instant) {
      if (show) {
        if (instant) {
          this._container.alpha = 1;
          this._container.visible = true;
          return;
        }

        this._container.alpha = 0;
        this._container.visible = true;

        gsap.to(this._container, {
          duration: 0.2,
          alpha: 1,
        });
      } else {
        if (instant) {
          this._container.alpha = 0;
          this._container.visible = false;
          return;
        }

        gsap.to(this._container, {
          duration: 0.4,
          alpha: 0,
          onComplete: () => {
            this._container.visible = false;
          },
        });
      }
    };

    setScale = function (scale) {
      this._container.scale.set(scale);
    };

    setMultiplier = function (multiplier) {
      this._multiplier.setText("X" + multiplier);
    };

    setMultiplierScale = function (scale) {
      this._multiplierContainer.visible = scale > 0;
      this._multiplierContainer.scale.set(scale * 2);
      this._currentMultiplierScale = scale;
    };
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    "winningsText",
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
